import htmlComponent from "htmlcomponent";

export default function (dom, opts) {
    let options = {
        linkSel: 'a',
        ...opts
    };

    const findLink = dom.querySelector(options.linkSel);
    const lastUrl = localStorage.getItem('last-filter');

    function init() {
        historyLink();
    }

    function isValidUrl(value) {
        if (!value || value === 'undefined' || value === 'null') {
            return false;
        }

        try {
            new URL(value, window.location.origin);
            return true;
        } catch (error) {
            return false;
        }
    }

    function historyLink() {
        if (!findLink) {
            return;
        }

        if (isValidUrl(lastUrl)) {
            findLink.href = lastUrl;
            return;
        }

        if (isValidUrl(document.referrer)) {
            findLink.href = document.referrer;
        }
    }

    init()

}
